import React from 'react';

import NotificationSvg from './notification.svg';

type NotificationIconProps = {
  width?: number,
  height?: number,
  className?: string,
}

export function NotificationIcon(props: NotificationIconProps) {
  return <NotificationSvg {...props} />;
}
